import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Orientation, Readout } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface OrientationReadoutParams {
  timeFrom: string
  timeTo: string
}

interface RequestParams {
  sensorUniqueId: string
  options?: Omit<UseMutationOptions<Orientation[], Error, OrientationReadoutParams>, 'mutationKey' | 'mutationFn'>
}

export const useSensorOrientationReadout = ({ sensorUniqueId, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<Orientation[], Error, OrientationReadoutParams>(
    [Entities.SensorReadout, 'movement-detection'],
    async ({ timeFrom, timeTo }: OrientationReadoutParams) => {
      const { data } = await api.v1AdminSensorsUniqueIdReadoutGet(sensorUniqueId, timeFrom, timeTo, 'orientation')
      return (data as Readout).orientation || []
    },
    options
  )
}
